import { usePunditUserContext } from "@circle-react/contexts";

export const useIsWorkflowsInCircleEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.workflows_in_circle_enabled);
};
